import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconSparks12 from './IconSparks12';
import IconSparks16 from './IconSparks16';
import IconSparks20Filled from './IconSparks20Filled';
import IconSparks20 from './IconSparks20';
import IconSparks24Filled from './IconSparks24Filled';
import IconSparks24 from './IconSparks24';
import IconSparks32Filled from './IconSparks32Filled';
import IconSparks32 from './IconSparks32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconSparks = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconSparks12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconSparks16 {...props} />}
            {size === IconSize.Size20 && props.filled && <IconSparks20Filled {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconSparks20 {...props} />}
            {size === IconSize.Size24 && props.filled && <IconSparks24Filled {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconSparks24 {...props} />}
            {size === IconSize.Size32 && props.filled && <IconSparks32Filled {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconSparks32 {...props} />}
        </span>
    );
};
IconSparks.displayName = 'FondueIconSparks';

export default memo(IconSparks);
